import { Stack } from "@mantine/core";
import { ChatBot } from "./ChatBot";

export function ChatBotPage() {
    return <>
        <Stack pos="relative" gap={0} h="calc(100vh - var(--app-shell-header-height, 0px) - var(--app-shell-footer-height, 0px) - var(--app-shell-padding) * 2)">
            <ChatBot />
        </Stack>
    </>
}